import LoadSpinner from "../components/load-spinner/LoadSpinner";
import LoadSpinnerIcon from "../components/load-spinner/LoadSpinnerIcon";

export function loadingWrapper(check,element=<></>,lg=false){
    if(check){
        return lg?<LoadSpinner/>:<LoadSpinnerIcon/>
    }
    return element;
}